import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SatDim from './SatDim';
import { LOADING_DEBOUNCE_DURATION } from '@common/constants';

const SatLoading = ({ message = '잠시만 기다려 주세요.' }) => {
  const { spinnerCount } = useSelector(state => state.commonReducer);
  const [isShowLoading, setIsShowLoading] = useState(false);
  const [zIndex, setZIndex] = useState(200);

  const handleShowLoading = () => {
    if (spinnerCount > 0) setIsShowLoading(true);
  };

  const handleHideLoading = () => {
    if (spinnerCount <= 0) setIsShowLoading(false);
  };

  useEffect(() => {
    if (isShowLoading) setZIndex($utils.getModalZIndex());
  }, [isShowLoading]);

  // Show Loading: 바로 실행
  useEffect(handleShowLoading, [spinnerCount]);

  // Hide Loading: Debouncing 실행
  $hooks.useDebounce({
    value: spinnerCount,
    duration: LOADING_DEBOUNCE_DURATION,
    callback: handleHideLoading,
  });

  return isShowLoading ? (
    <>
      <div className="layer-loading" style={{ zIndex: zIndex + 10 }}>
        <div className="cont">
          <div className="ico-loading"></div>
          <p className="layer-text text-center">{message}</p>
        </div>
      </div>

      <SatDim isShow zIndex={zIndex} />
    </>
  ) : (
    <></>
  );
};

export default SatLoading;
